module.exports = __webpack_public_path__ + "images/logo-text.58b459a.svg";